
import React, { Component } from 'react';
import './add-admin.scss'
import { Modal, ModalBody } from "reactstrap";

import SchoolApi from '../../../apis/school'
import Dropdown from '../../common/dropdown-v2/dropdown';
// import CommonApi from '../../../apis/common'
import { ImageConstants, } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import CommonUtils from '../../../utility/common-utilities';

class AddAdminComponent extends Component {
    constructor(props) {
        super(props)

    }



    state = {
        existingUsers: [],
        types: [],
        title: "ADD ADMIN",
        selectedUser: null,
        countryCodeDropdown: [],
        existingUsersDropdown: []
    }

    userHash = {}

    componentDidMount() {
        this.getStaffs()
    }


    getStaffs(payload = {}) {
        payload.types = `nin/ADMIN`
        SchoolApi.getStaffs(payload)
            .then(response => {
                let items = [];
                this.userHash = {}
                for (let i = 0; i < response?.response?.length; i++) {
                    items.push({
                        title: response?.response[i].firstName,
                        value: response?.response[i]._id,
                    })
                    this.userHash[response?.response[i]._id] = response?.response[i]
                }

                this.setState({ existingUsersDropdown: items })
            }).catch(err => {
            })

    }

    onSave() {
        if (!this.state.selectedUser || this.state.isSubmit == true) return

        let user = this.userHash[this.state.selectedUser]
        if (!user?.types || !user.types.length) user.types = []

        let payload = {
            _id: user?._id,
            isAddAsAdmin: true,
            types: [...user.types, { type: "ADMIN" }],
        }

        this.setState({ isSubmit: true })

        SchoolApi.updateStaff(payload).then(response => {
            this.props.onSave()
            this.setState({ isSubmit: false })
        }).catch(err => {
            this.setState({ isSubmit: false })
        })
    }

    validatePayload(payload) {

        return true
    }

    addNewContact = () => {
        this.props.delegate && this.props.delegate.showAddContactModal && this.props.delegate.showAddContactModal({}, 'CREATE');
    }

    onSelectUser = (option) => {
        if (option) {
            this.setState({ selectedUser: option?.value })
        } else {
            this.setState({ selectedUser: null })
        }

    }

    render() {
        return (
            <Modal className="cw-custom-modal" isOpen={this.props.show} toggle={this.props.onClose} size={this.props.size || 'md'}>

                <ModalBody >
                    <div className="add-admin">
                        <div className="row">
                            <div className="col">
                                <img className="close-icon cursor-pointer" onClick={this.props.onClose} src={getImageSource(ImageConstants.CROSS)} />
                            </div>
                        </div>
                        <div className="header-text text-center">
                            <span>{this.state.title}</span>
                        </div>

                        {/* <div className='text-center pt-5'>

                            <div className='cw-input-label'>SELECT FROM EXISTING CONTACTS</div>
                            <div className='row align-items-center d-inline-block'>

                                <div className='d-inline-block pr-3 '>
                                    <Dropdown
                                        key="users"
                                        placeholder='Select from the list'
                                        options={this.existingUsersDropdown}
                                        onSelect={(option) => this.onSelectUser(option)}
                                        text="title"
                                        style={{ background: "#F6F7F5" }}
                                        invalid={this.state.isSubmit && !this.state.selectedUser}
                                    />
                                </div>
                                <div className='d-inline-block'>
                                    <img className="close-icon cursor-pointer" onClick={this.addNewContact} src={getImageSource(ImageConstants.ADD)} />
                                </div>
                            </div>


                        </div> */}
                        <div className='row pt-5'>
                            <div className='col-2'></div>
                            <div className='col-8'>
                                <div className='cw-input-label'>SELECT FROM EXISTING CONTACTS</div>
                                <Dropdown
                                    key="users"
                                    placeholder='Select from the list'
                                    options={this.state.existingUsersDropdown}
                                    onSelect={(option) => this.onSelectUser(option)}
                                    text="title"
                                    style={{ background: "#F6F7F5" }}
                                    invalid={this.state.isSubmit && !this.state.selectedUser}
                                />
                            </div>
                            <div className='col-2 close-icon-wrapper'>
                                <img className="custom-close-icon cursor-pointer" onClick={this.addNewContact} src={getImageSource(ImageConstants.ADD)} />
                            </div>

                        </div>



                        <div className="text-center pt-5">
                            {this.state.selectedUser ?
                                <button className="cw-button-primary" onClick={() => this.onSave()}>
                                    Send Invite
                                </button>
                                :
                                <button className="cw-button-disabled" >
                                    Send Invite
                                </button>
                            }
                        </div>
                    </div>
                </ModalBody>

            </Modal >
        );
    }
}

export default AddAdminComponent;